"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorPage = void 0;
const react_1 = __importDefault(require("react"));
const colors_1 = require("../../../theme/colors");
const ErrorPage_styles_1 = require("./ErrorPage.styles");
const ErrorPage = ({ title, message, secondMessage, errorCode, children }) => {
    return (react_1.default.createElement(ErrorPage_styles_1.Wrapper, null,
        react_1.default.createElement(ErrorPage_styles_1.ContentWrapper, null,
            react_1.default.createElement(ErrorPage_styles_1.Title, null, title),
            message && react_1.default.createElement(ErrorPage_styles_1.Message, null, message),
            secondMessage && react_1.default.createElement(ErrorPage_styles_1.Message, null, secondMessage),
            errorCode && react_1.default.createElement(ErrorPage_styles_1.Message, { "$color": colors_1.GREY3 }, errorCode),
            react_1.default.createElement(ErrorPage_styles_1.ChildrenWrapper, null, children))));
};
exports.ErrorPage = ErrorPage;
//# sourceMappingURL=ErrorPage.js.map